module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1990.e08b098e.jpg";